import {createApp} from 'vue'
import {createPinia} from 'pinia'
import vuetify from './plugins/vuetify'
import {loadFonts} from './plugins/webfontloader'
import App from './App.vue'
import {useRouter} from './plugins/obscore'
import obscore from './plugins/obscore'
import '@/assets/css/VOverride.css';

if (navigator.serviceWorker) {
    navigator.serviceWorker.register('/interFetch.js').then(function(reg){
        if (reg.active) console.log('serviceworker installed')
    })
        .catch(function(err){
            console.log('registration failed: ' + err)
        })
}

loadFonts()
const pinia = createPinia()

createApp(App)
  .use(pinia)
  .use(vuetify)
  .use(obscore)
  .use(useRouter())
  .mount('#app')
